import { MediaDeviceRepository } from 'core/repositories/MediaDeviceRepository';
import { createDependency } from 'services/createDependency';

export const [useMediaDeviceRepository, withMediaDeviceRepository] = createDependency<MediaDeviceRepository>();
